import "../../utils/tailwind.css";
import { useRef, useState } from "react";
import AttachIcon from "../svg/attach";
import CloseFill from "../svg/close-fill";
import Loader from "../svg/loader";

export default function FileUpload() {
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(null);

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true);
      setUploadingFile(file.name);

      setTimeout(() => {
        const newFile = {
          file_name: file.name,
          file,
        };
        setFiles([newFile]);
        setLoading(false);
        setUploadingFile(null);

        event.target.value = "";
      }, 3000);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.file_name !== fileName));
  };

  return (
    <div className="flex items-center space-x-7">
      <div
        role="button"
        tabIndex={0}
        className="flex justify-center items-center bg-[#EBEAF7] w-24 rounded-[8px] cursor-pointer p-2 border-[#EBEAF7] border-[2px]"
        onClick={handleFileClick}>
        <AttachIcon className="w-5 h-5" />
        <span className="text-[black] text-[14px] ml-2 font-[400]">Attach</span>
      </div>

      {loading && (
        <div className="flex justify-between items-center bg-[#EBEAF7] rounded-[8px] min-w-[12rem] border-dotted border-[1px] border-[#ABABAB]">
          <span className="text-[14px] p-2 font-[400] bg-[white] text-white rounded-l-[8px] truncate max-w-[6rem]">
            {uploadingFile}
          </span>
          <Loader className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-white mr-2" />
        </div>
      )}

      {files.map((item, index) => (
        <div
          key={index}
          className="flex justify-between items-center bg-[#F0F0F0] rounded-[8px] min-w-[12rem] border-dotted border-[1px] border-[#ABABAB] p-2">
          <span className="text-[14px] ml-2 font-[400] truncate">
            {item.file_name}
          </span>
          <CloseFill
            role="button"
            tabIndex={0}
            className="cursor-pointer min-w-[20px]"
            onClick={() => handleRemoveFile(item.file_name)}
          />
        </div>
      ))}

      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.ppt,.xlsx,.jpg"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </div>
  );
}
